
import "/app/src/components/Layout/SiderResizeHandle.module.less?modules";
export default {"dragMask": `dragMask-sxqeAALv`,"hovering": `hovering-6EWwGiFq`,"dragging": `dragging-OCTGomwh`,"hitBox": `hitBox-XAPFCGKj`,"handle": `handle-98ZVkHtP`}
